import request from '@/utils/request';
//详情
export function getMemberDetail(values) {
  const { memberID } = values || {};
  return request('/member/queryMemberInfo', {
    method: 'POST',
    data: {
      id: memberID,
    },
  });
}
//优惠券列表
export function getUserGroupList(values) {
  return request('/profile/queryGroupPage', {
    method: 'POST',
    data: values,
  });
}
//获取活动相关信息
export function getActivityInfo(values) {
  return request('/activityGroup/queryOne', {
    method: 'POST',
    data: values,
  });
}
//新增活动人群
export function addActivityGroup(values) {
  return request('/activityGroup/add', {
    method: 'POST',
    data: values,
  });
}
//更新活动人群
export function updateActivityGroup(values) {
  return request('/activityGroup/update', {
    method: 'POST',
    data: values,
  });
}

// 获取微信模板信息
export function getWechatTemplateList(values) {
  return request('/message/queryWechatTemplateList', {
    method: 'POST',
    data: values,
  });
}
// 获取短信模板消息
export function getSmsTemplateList() {
  return request('/sms/queryTemplateList', {
    method: 'GET',
    // params: values,
  });
}
// 获取周期类型列表
export function getCycleTypeList() {
  return request('/activityGroup/cycleTypeList', {
    method: 'GET',
    // params: values,
  });
}
// 获取每月天数列表
export function getMonthDayList() {
  return request('/activityGroup/monthDayList', {
    method: 'GET',
    // params: values,
  });
}
// 获取每周天数
export function getWeekDayList() {
  return request('/activityGroup/weekDayList', {
    method: 'GET',
    // params: values,
  });
}

//会员异动调整
export function postManualOperation(values) {
  return request('/manualOperation', {
    method: 'POST',
    data: values,
  });
}

//会员发放详情
export function getCouponDetail(values) {
  return request('/manualOperation/couponDetail', {
    method: 'POST',
    data: values,
  });
}

//调整数据详情-调整优惠券有效期/状态
export function getAdjustCouponList(values) {
  return request('/manualOperation/adjustCouponList', {
    method: 'POST',
    data: values,
  });
}
